import { render, staticRenderFns } from "./index.page.vue?vue&type=template&id=2f289d2a&scoped=true&"
import script from "./index.page.vue?vue&type=script&lang=js&"
export * from "./index.page.vue?vue&type=script&lang=js&"
import style0 from "./index.page.vue?vue&type=style&index=0&id=2f289d2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f289d2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f289d2a')) {
      api.createRecord('2f289d2a', component.options)
    } else {
      api.reload('2f289d2a', component.options)
    }
    module.hot.accept("./index.page.vue?vue&type=template&id=2f289d2a&scoped=true&", function () {
      api.rerender('2f289d2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/walletSubmit/index.page.vue"
export default component.exports